<template>
    <div v-if="!editing" class="input-group">
        <a class="form-control" :href="value">{{ value ? value : placeholder }}</a>
        <span class="input-group-btn">
            <button v-on:click="editing=!editing" class="btn btn-primary" type="button"><i class="fa fa-wrench"
                                                                                           aria-hidden="true"></i></button>
        </span>
    </div>

    <div v-else class="input-group">
        <input type="text" class="form-control" v-model="value" :placeholder="placeholder">
        <span class="input-group-btn">
            <button :disabled="saving" v-on:click="save()" class="btn btn-success" type="button">
                <i v-if="saving" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                <i v-else class="fa fa-save" aria-hidden="true"></i>
            </button>
        </span>
    </div>
</template>

<script>
export default {
    name: "editable-link",
    props: ['placeholder', 'url', 'update_ajax'],
    data() {
        return {
            'editing': false,
            'saving': false,
            'value': '',
        };
    },
    computed: {},
    created() {
        this.value = this.url;
        if (this.value === '') {
            this.editing = true;
        }
    },
    methods: {
        save() {
            this.saving = true;

            axios.post(
                this.update_ajax,
                {
                    'value': this.value
                }
            ).then(response => {
                console.log(response);
                this.saving = false;
                this.value = response.data['value'];

                // Allow the user to save it as empty, but in that case, remain in edit mode
                console.log("The value is |" + this.value + "|");
                if (this.value !== null) {
                    this.editing = false;
                }
            });
        }
    }
}
</script>

<style scoped>
a.form-control {
    color: #337ab7;
    background-color: #eee;
}
</style>